import React from 'react';
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import NavBar from "../../layouts/navbar/navbar.component";
import DrawerNav from "../../components/drawer/drawer.component";
import SpecialFeaturesLayout from "../../layouts/specialFeatures/SpecialFeatures.layout";
import Footer from "../../layouts/footer/footer.component";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import SFeature from '../../assets/image/specialFeatures.png'

const SpecialFeaturesPage = () => {
    return (
        <div>
            <TopOfNav/>
            <NavBar/>
            <DrawerNav/>
            <SubHeaderComponent imageSrc={SFeature} pageName='ویژگی های منحصر به فرد زیتونیکس' />
            <SpecialFeaturesLayout/>
            <Footer/>
        </div>
    );
};

export default SpecialFeaturesPage;